import AthleteTableHeader from "./AthleteTableHeader";
import useAthleteStore from "providers/AthletesProvider/useAthleteStore";
import AthleteStoreContext from "providers/AthletesProvider/contexts/AthleteStoreContext";
import Tables from "components/Tables";
import useAthletesFilter from "../hooks/useAthletesFilter";
import AthleteTableRowContainer from "./AthleteTableRowContainer";

interface AthleteTableProps {
  TableControlsComponent: (props: any) => JSX.Element;
}

function AthleteTable(props: AthleteTableProps) {
  const { TableControlsComponent } = props;
  const athletes = useAthleteStore();
  const filteredAthletes = useAthletesFilter(athletes);

  return (
    <AthleteStoreContext.Provider value={filteredAthletes}>
      <Tables.Components.PaperCard>
        <TableControlsComponent />
        <AthleteTableHeader />
        <AthleteTableRowContainer />
      </Tables.Components.PaperCard>
    </AthleteStoreContext.Provider>
  );
}

export default AthleteTable;
